import React, { useState } from 'react';
import MainLayout from '../components/MainLayout';
import { PageHeader } from '../components/ui/PageHeader';
import { Tabs, tabId, tabPanelId } from '../components/ui/Tabs';
import TrainingTracks from './TrainingTracks';
import TrainingSessions from './TrainingSessions';

type TrainingSection = 'tracks' | 'sessions';

const TRAINING_TABS = [
  { id: 'tracks', label: 'Training Tracks', tutorialId: 'training-tracks-tab' },
  { id: 'sessions', label: 'Training Sessions', tutorialId: 'training-sessions-tab' },
];

const Training: React.FC = () => {
  const [currentTab, setCurrentTab] = useState<TrainingSection>('tracks');
  // The active tab portals its toolbar (refresh, Create Track) into the page
  // header and its filters into the tab row, so both sit where every other
  // page keeps them.
  const [headerActions, setHeaderActions] = useState<HTMLElement | null>(null);
  const [tabFilters, setTabFilters] = useState<HTMLElement | null>(null);

  return (
    <MainLayout title="Training">
      <div className="p-2">
        <PageHeader
          title="Training"
          description="Manage training tracks and review training sessions"
          actions={<div ref={setHeaderActions} className="flex items-center gap-2" data-testid="training-header-actions" />}
        />

        <Tabs
          idPrefix="training"
          ariaLabel="Training sections"
          value={currentTab}
          onChange={(id) => setCurrentTab(id as TrainingSection)}
          items={TRAINING_TABS.map((tab) => (
            tab.id === currentTab ? { ...tab, panelId: tabPanelId('training', tab.id) } : tab
          ))}
          actions={<div ref={setTabFilters} className="flex flex-wrap items-center justify-end gap-2" data-testid="training-tab-filters" />}
        />

        <div
          role="tabpanel"
          className="pt-6"
          id={tabPanelId('training', currentTab)}
          aria-labelledby={tabId('training', currentTab)}
        >
          {currentTab === 'tracks' ? (
            <TrainingTracks actionsContainer={headerActions} filtersContainer={tabFilters} />
          ) : (
            <TrainingSessions actionsContainer={headerActions} filtersContainer={tabFilters} />
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default Training;
